<template>
  <v-hover @input="isHover = $event">
    <v-card
      outlined
      :elevation="isHover ? 10 : 0"
      class="relative rounded-4 transition-timing--ease-in-out transition-duration--0_3s transition-property--transform"
      width="100%"
      height="100%"
      v-bind:class="{ 'translate-Y--bottom-6': isHover }"
      @click.stop="
        $router.push({
          name: $router.currentRoute.name,
          query: {
            ...$route.query,
            destinationId: destination.id
          }
        })
      "
    >
      <!-- Destination Image Background and geoInformationSection -->
      <div class="card-wrapper">
        <BaseSheet
          color="grey lighten-1"
          class="absolute top-0 bottom-0 left-0 right-0 rounded-t-4"
          style="overflow:hidden"
        >
          <v-img :src="destinationPicture" width="100%" height="100%">
            <div
              class="d-flex flex-column align-center destination-geoinformations"
              style="height:100%"
            >
              <!-- Department -->
              <v-sheet
                color="white"
                height="20px"
                class="px-4 rounded-b-2 d-flex align-center"
              >
                <span
                  class="text-body-2 grey--text text--darken-1 font-weight-medium d-inline-block text-truncate"
                >
                  {{ destination.location.properties.department }}
                </span>
              </v-sheet>
            </div>
          </v-img>
        </BaseSheet>
      </div>
      <!-- destination Content -->
      <v-card-title class="flex-nowrap">
        <v-icon
          color="primary"
          size="24"
          class="mr-2 flex-shrink-0 align-self-start"
        >
          {{ `$${destination.category.nameEn}` | noSpace }}
        </v-icon>
        <span class="text-h6 word-break-break-word">
          {{ destination.name | firstLetterUppercase }}
        </span>
      </v-card-title>
      <SearchDestinationCardDistanceInformation
        v-if="
          searchParams.longName != destination.location.properties.longName &&
            destination.distance !== null
        "
        :distance="destination.distance"
        :routeUrl="destination.routeUrl"
        :searchPlaceType="searchParams.placeType"
        :searchShortName="searchParams.shortName"
      ></SearchDestinationCardDistanceInformation>
    </v-card>
  </v-hover>
</template>

<script>
import SearchDestinationCardDistanceInformation from "./SearchDestinationCardDistanceInformation";
export default {
  name: "DestinationCard",
  // CHILD COMPONENTS
  components: {
    SearchDestinationCardDistanceInformation
  },
  // DATA
  props: {
    destination: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isHover: false
    };
  },
  computed: {
    destinationPicture() {
      if (this.destination.mainPicture)
        return this.$vuetify.breakpoint.xs
          ? this.destination.mainPicture.small
          : this.destination.mainPicture.medium;
      return require("@/assets/defaultCardPicture.png");
    },
    searchParams() {
      return this.$store.state.search.searchParams;
    }
  },
  // METHODS
  methods: {
    getFontSizeClass(length) {
      switch (true) {
        case length < 15:
          return "text-h2";
        case length < 20:
          return "text-h3";
        case length < 40:
          return "text-h4";
        default:
          return "text-h5";
      }
    }
  },
  // WATCHERS
  watch: {
    isHover(value) {
      if (value)
        return this.$store.dispatch(
          "search/setHoverActiveDestination",
          this.destination
        );
      return this.$store.dispatch("search/setHoverActiveDestination", {});
    }
  }
};
</script>

<style scoped>
.translate-Y--bottom-6 {
  transform: translateY(-6px);
}
.card-wrapper {
  position: relative;
  padding-top: 61.8%;
  width: 100%;
}
</style>
